module.exports = __webpack_public_path__ + "img/v_diamonds.01371843.png";